import { IonFooter, IonIcon } from "@ionic/react";
import { star } from "ionicons/icons";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { URLS } from "../../urls";
import "./style.css";

class Footer extends Component {
    render() {
        return (
            <IonFooter className="footer__footer">
                <a
                    href={URLS.SAFSAL.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "inline-block" }}
                >
                    <img className="footer__icon" src="assets/icon/favicon.png" alt="safsal logo" />
                </a>
                {/* <Link to={URLS.REVIEW.url}>
                    <IonIcon icon={star} className="footer__review" />
                </Link> */}
            </IonFooter>
        );
    }
}
export default Footer;
